var React = require('react');

function WaveLg (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 5.4996C53.8918 -14.5004 204.725 16.4999 420.452 157.5C636.178 298.5 918.393 295 1132.21 203.5C1271.11 147.9 1417.77 157.5 1512 203.5V280H0V5.4996Z"}));
}

WaveLg.defaultProps = {"viewBox":"0 0 1512 280","fill":"none"};

module.exports = WaveLg;

WaveLg.default = WaveLg;
